import { C } from "../data";

const DEFAULT_SHOP = [
  { label: "New Arrivals", action: "shop_new" },
  { label: "Top",          action: "shop_Top" },
  { label: "Bottom",       action: "shop_Bottom" },
  { label: "Best Sellers", action: "shop_best" },
];
const DEFAULT_INFO = [
  { label: "About",      action: "about" },
  { label: "Stockist",   action: "info_stockist" },
  { label: "Recruit",    action: "info_recruit" },
  { label: "Membership", action: "info_membership" },
];
const DEFAULT_HELP = [
  { label: "Contact",  action: "info_contact" },
  { label: "FAQ",      action: "info_faq" },
  { label: "Returns",  action: "info_returns" },
  { label: "Shipping", action: "info_shipping" },
];

const resolveAction = (action, nav) => {
  if (action === "about") return () => nav.goAbout?.();
  if (action.startsWith("shop_")) return () => nav.goShop?.(action.slice(5));
  if (action.startsWith("info_")) return () => nav.goInfo?.(action.slice(5));
  return () => {};
};

const buildCols = (footerLinks, nav) => {
  const toLinks = (items, defaults) =>
    (items || defaults)
      .filter(l => l.visible !== false)
      .map(l => ({ label: l.label, fn: resolveAction(l.action, nav) }));

  return [
    { title: "SHOP", links: toLinks(footerLinks?.shop, DEFAULT_SHOP) },
    { title: "INFO", links: toLinks(footerLinks?.info, DEFAULT_INFO) },
    { title: "HELP", links: toLinks(footerLinks?.help, DEFAULT_HELP) },
  ];
};

/* variant="full" → 4-column layout
   variant="simple" → 1-line */
export default function Footer({ nav = {}, variant = "full" }) {
  if (variant === "simple") {
    return (
      <footer style={{ background: C.ink, borderTop: "1px solid #2A2A2A" }}>
        <div style={{ maxWidth: 1440, margin: "0 auto", padding: "48px 48px 32px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <span style={{ fontFamily: "'DM Serif Display',serif", fontSize: 13, letterSpacing: 4, color: C.bg }}>UNDERLOOKED</span>
          <div style={{ display: "flex", gap: 20 }}>
            {[
              { label: "개인정보처리방침", type: "privacy" },
              { label: "이용약관", type: "terms" },
            ].map(({ label, type }) => (
              <a key={type} href={`/info/${type}`}
                onClick={(e) => { e.preventDefault(); nav.goInfo?.(type); }}
                style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 2, color: "rgba(242,241,237,0.35)", textDecoration: "none", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.color = "rgba(242,241,237,0.7)"}
                onMouseLeave={e => e.currentTarget.style.color = "rgba(242,241,237,0.35)"}
              >{label}</a>
            ))}
          </div>
          <span style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 3, color: "rgba(242,241,237,0.35)" }}>© 2025 UNDERLOOKED. ALL RIGHTS RESERVED.</span>
        </div>
      </footer>
    );
  }

  const cols = buildCols(nav.footerLinks, nav);

  return (
    <footer style={{ background: C.ink, borderTop: "1px solid #2A2A2A" }}>
      <div style={{ maxWidth: 1440, margin: "0 auto", padding: "56px 48px 40px" }}>
        <div className="footer-cols" style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 48, marginBottom: 48 }}>
          <div>
            <div style={{ fontFamily: "'DM Serif Display',serif", fontSize: 13, letterSpacing: 4, color: C.bg, marginBottom: 14 }}>UNDERLOOKED</div>
            <p style={{ fontFamily: "'Presentation5',sans-serif", fontSize: 12, fontWeight: 300, color: "rgba(242,241,237,0.35)", lineHeight: 1.9, maxWidth: 220 }}>
              움직임을 위해 설계된 옷.<br />For movement, not distraction..
            </p>
            <div style={{ marginTop: 24, display: "flex", gap: 14 }}>
              {[
                { label: "Instagram", url: nav.socialLinks?.instagram },
                { label: "TikTok",    url: nav.socialLinks?.tiktok },
                { label: "Kakao",     url: nav.socialLinks?.kakao },
              ].filter(s => s.url).map(s => (
                <a key={s.label} href={s.url} target="_blank" rel="noopener noreferrer"
                  style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 2, color: "rgba(242,241,237,0.35)", textDecoration: "none", transition: "color .2s" }}
                  onMouseEnter={e => e.currentTarget.style.color = C.accent}
                  onMouseLeave={e => e.currentTarget.style.color = "rgba(242,241,237,0.35)"}>{s.label}</a>
              ))}
            </div>
          </div>
          {cols.map(col => (
            <div key={col.title}>
              <p style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 4, color: "rgba(242,241,237,0.4)", marginBottom: 14 }}>{col.title}</p>
              {col.links.map(({ label, fn }) => (
                <button key={label} className="fl"
                  style={{ background: "none", border: "none", textAlign: "left" }}
                  onClick={fn}>{label}</button>
              ))}
            </div>
          ))}
        </div>
        <div style={{ borderTop: "1px solid #2A2A2A", paddingTop: 22, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
          <span style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 3, color: "rgba(242,241,237,0.35)" }}>© 2025 UNDERLOOKED. ALL RIGHTS RESERVED.</span>
          <div style={{ display: "flex", gap: 20, alignItems: "center" }}>
            {[
              { label: "개인정보처리방침", type: "privacy" },
              { label: "이용약관", type: "terms" },
            ].map(({ label, type }) => (
              <a key={type} href={`/info/${type}`}
                onClick={(e) => { e.preventDefault(); nav.goInfo?.(type); }}
                style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 2, color: "rgba(242,241,237,0.35)", textDecoration: "none", transition: "color .2s", cursor: "pointer" }}
                onMouseEnter={e => e.currentTarget.style.color = "rgba(242,241,237,0.7)"}
                onMouseLeave={e => e.currentTarget.style.color = "rgba(242,241,237,0.35)"}
              >{label}</a>
            ))}
          </div>
          <span style={{ fontFamily: "'Pretendard',sans-serif", fontWeight:500, fontSize: 9, letterSpacing: 3, color: "rgba(242,241,237,0.35)" }}>SEOUL, KOREA</span>
        </div>
      </div>
    </footer>
  );
}
